export default "__VITE_PUBLIC_ASSET__986cc9ae__"